import type { Equality } from "../types/scene";

type ConstraintVisualizationUpdater = (constraints: Equality[]) => void;

let updater: ConstraintVisualizationUpdater | null = null;

export function setConstraintVisualizationUpdater(next: ConstraintVisualizationUpdater | null) {
  updater = typeof next === "function" ? next : null;
}

export function hasConstraintVisualizationUpdater(): boolean {
  return typeof updater === "function";
}

export function updateConstraintVisualization(constraints: Equality[]) {
  if (!updater) return;
  updater(Array.isArray(constraints) ? constraints : []);
}
